import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart3, Bell, ClipboardList, FileText, Home, Route as RouteIcon, UserCog } from 'lucide-react';
const links = [{
  to: '/admin',
  label: 'Admin Hub',
  icon: Home
}, {
  to: '/analytics',
  label: 'Analytics',
  icon: BarChart3
}, {
  to: '/feedback',
  label: 'Reports',
  icon: FileText
}, {
  to: '/assessment',
  label: 'Users',
  icon: UserCog
}, {
  to: '/survey',
  label: 'Survey',
  icon: ClipboardList
}, {
  to: '/pathway-builder',
  label: 'Pathway Builder',
  icon: RouteIcon
}];
export function PathwayNav() {
  const {
    pathname
  } = useLocation();
  return <div className="bg-white border-b border-gray-200" data-id="element-1658" data-mp="31l9imr4774j4">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1659" data-mp="2wo9dqjj347tl">
        <div className="flex items-center h-16" data-id="element-1660" data-mp="2wq3zg026k3yq">
          <div className="text-[#E53E3E] font-bold text-xl" data-id="element-1661" data-mp="1q8qljh7edbf3">LOGO</div>

          <nav aria-label="Primary" className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-1662" data-mp="1l8ufzdj1xbxf">
            {links.map(({
            to,
            label,
            icon: Icon
          }) => {
            const active = pathname === to;
            return <Link key={to} to={to} aria-current={active ? 'page' : undefined} className={active ? 'flex items-center gap-2 text-[#00638C] border-b-2 border-[#00638C] pb-[22px] pt-[22px] transition-colors text-sm font-medium' : 'flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium'} data-id="element-1663" data-mp="1tgplv64ejq0x">
                  <Icon size={18} data-id="element-1664" data-mp="vrm8tdymjqlv" />
                  <span className="hidden md:inline" data-id="element-1665" data-mp="10sjyeblyrmxe">{label}</span>
                </Link>;
          })}
          </nav>

          <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-1666" data-mp="mubxxtppy3hh">
            <Link to="/alerts" aria-label="Notifications" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1667" data-mp="qv5lglz91g9u">
              <Bell size={20} data-id="element-1668" data-mp="2oqujjmi5o1sh" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-1669" data-mp="2opje7i92alz9" />
            </Link>
            <Link to="/profile" className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-1670" data-mp="2js9g7e7lx1zt">
              <span className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-1671" data-mp="3cgoutzmttiam">
                LT
              </span>
              <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-1672" data-mp="32hzbs3j71rss">
                Linda Taylor
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}